import {Component, Input, OnInit} from '@angular/core';
import {LokijsService} from '../../services/database/lokijs.service';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'job-certificate',
    templateUrl: './job-certificate.component.html',
    styleUrls: ['./job-certificate.component.scss'],
})

export class JobCertificateComponent implements OnInit {
    @Input() document: DocumentModel;
    currentCertificate: any;
    jobCertList: any[];

    // TODO Unselect the certificate
    constructor(private loki: LokijsService) {
    }

    ngOnInit() {
        this.jobCertList = this.loki.getTable('jobcertificatetext', 'id').chain().data();
        console.log( this.jobCertList );

        //if (this.jobCertList.length > 0) {
        //    this.currentCertificate = this.jobCertList[0];
       // }

       if(  this.document.serviceJob.jobCertificateTextId === 0 ){
            this.currentCertificate =  {
                id: 0,
                name: 'none'
            };
       }else{
            this.currentCertificate = this.jobCertList.filter((each) => {
                if( each.id === this.document.serviceJob.jobCertificateTextId  ){
                    return each;
                }
            });
       }



        console.log(this.jobCertList);
        console.log(this.currentCertificate);
    }

    setCert() {
        this.document.serviceJob.jobCertificateTextId = this.currentCertificate.id;
        //this.document.serviceJob.jobCertificateTextIdObj = this.currentCertificate;
    }

    compareById(o1, o2) {
        return o1.id === o2.id
      }
}
